import axiosInstance from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";
import { authHeaders } from "../util/apiEmptyList";
import { ADS_PAGE_SIZE } from "../util/adsPaging";

const headers = () => authHeaders(getToken());

export const SponsorshipAPI = {
    getSponsorsByClub: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsors/all/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return { ...response.data, Data: response.data?.Data ?? [] };
    },

    getSponsorById: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsors/${id}/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    searchSponsors: async function (name, clubId) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsors/search?name=${encodeURIComponent(name)}&clubId=${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return { ...response.data, Data: response.data?.Data ?? [] };
    },

    createSponsor: async function (sponsor) {
        const response = await axiosInstance.request({
            url: "/sponsorship/sponsors",
            method: "POST",
            data: sponsor,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    updateSponsor: async function (id, clubId, sponsor) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsors/${id}/clubId/${clubId}`,
            method: "PUT",
            data: sponsor,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    deleteSponsor: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsors/${id}/clubId/${clubId}`,
            method: "DELETE",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    getSponsorshipsByClub: async function (clubId, page = 0, size = ADS_PAGE_SIZE) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsorships/clubId/${clubId}`,
            method: "GET",
            params: { page, size },
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    createSponsorship: async function (sponsorship) {
        const response = await axiosInstance.request({
            url: "/sponsorship/sponsorships",
            method: "POST",
            data: sponsorship,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    updateSponsorship: async function (id, clubId, sponsorship) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsorships/${id}/clubId/${clubId}`,
            method: "PUT",
            data: sponsorship,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    deleteSponsorship: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/sponsorship/sponsorships/${id}/clubId/${clubId}`,
            method: "DELETE",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    getPaymentsByClub: async function (clubId, page = 0, size = ADS_PAGE_SIZE) {
        const response = await axiosInstance.request({
            url: `/sponsorship/payments/clubId/${clubId}`,
            method: "GET",
            params: { page, size },
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    createPayment: async function (payment) {
        const response = await axiosInstance.request({
            url: "/sponsorship/payments",
            method: "POST",
            data: payment,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    updatePayment: async function (id, clubId, payment) {
        const response = await axiosInstance.request({
            url: `/sponsorship/payments/${id}/clubId/${clubId}`,
            method: "PUT",
            data: payment,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    deletePayment: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/sponsorship/payments/${id}/clubId/${clubId}`,
            method: "DELETE",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },
};
